import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Api-Key ${process.env.NEXT_PUBLIC_API_KEY}`,
  },
  withCredentials: true,
});

const axiosInstanceAPI = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_CARRY_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export { axiosInstance, axiosInstanceAPI };
